/* ========== ~~~~~~~~~~ DIMENSIONS AND METRICS ~~~~~~~~~~ ========== */
// react imports
import React from "react";
import injectSheet from "react-jss";
import {useDispatch, useSelector} from "react-redux";

//styles
import styles from "./dimensionsandmetrics_styles";

// external components
import {Tip} from "@insticator/insticator-ui";

// all external imports
import ChecklistSection from "../checklistsection/checklistsection";
import Checklist from "../checklist/checklist";
import DraggableList from "../../../../material/draggablelist/draggablelist";
import {updateReportForm} from "../../../../state/slices/report";

//statics
import {
    DIMENSION_TYPES,
    DIMENSIONS,
    DIMENSIONS_OPTIONS, DISABLE_DIMENSION_AND_METRIC_SUPPORT,
    INTERVAL_DIMENSION,
    METRICS, METRICS_TYPES,
    MONETIZATION_METRICS, NO_PAGEVIEW_DIMENSION_SUPPORT, NO_PAGEVIEW_METRIC_SUPPORT,
    PERFORMANCE_METRICS,
    PREBID_MONETIZATION_METRICS,
    PREBID_VIDEO_METRICS, PRODUCT_METRIC_SUPPORT,
    STANDARD_DIMENSION, TOTAL_METRICS_OPTIONS
} from "../../reportbuilder/monetizationform/consts";
import {INTEGRATION, PRODUCT_TYPE} from "../consts";



export default injectSheet(styles)((props) => {
    const {uuid, dimensionOptions, metricsOptions} = props;
    const formValues = useSelector((state) => state.report[uuid]);
    const mocked = useSelector((state) => state.session.mocked)
    const dispatch = useDispatch();

    // messages
    const PRODUCT_SUPPORT_METRIC = 'These metrics are only available when the dimension "product" is selected.';
    const PRODUCT_SUPPORT_DIMENSION = 'This dimension is only available when "product" is also selected."';
    const METRIC_FORM_PG_VIEW = 'Choose the dimensions you want to include in your report. Avg Page RPM and Page Views support device, site, country, and date only.';
    const DISABLE_PRODUCT_METRIC = 'This metric is not compatible with the dimensions "Product", "Ad Unit", and "Revenue Type". Please remove it in order to use this metric.';


    const getDimensions= (type) => {
        const result = dimensionOptions.filter(o => o.type === type);
        const disableDimensions = (options, condition) => {
           return options.map(o => {
                if(condition.includes(o.value)) {
                    return ({...o,isDisabled: true})
                }
                else return o;
            });
        }

        if(includesOptions(METRICS, NO_PAGEVIEW_METRIC_SUPPORT)) {
            return disableDimensions(result, NO_PAGEVIEW_DIMENSION_SUPPORT);
        }
        if(!includesOptions(DIMENSIONS, DISABLE_DIMENSION_AND_METRIC_SUPPORT)) {
            return disableDimensions(result, PRODUCT_METRIC_SUPPORT);

        } return result;
    }

    // to be refactored
    const getMetrics= (type) => {
        if (type === MONETIZATION_METRICS && includesOptions(DIMENSIONS, NO_PAGEVIEW_DIMENSION_SUPPORT)) {
            return metricsOptions.filter(o => o.type === type).map(o => {
                if(NO_PAGEVIEW_METRIC_SUPPORT.includes(o.value)) {
                    return ({...o,isDisabled: true})
                }
                else return o;
            })
        }
        else {
            return metricsOptions.filter(o => o.type === type)
        }
    }

    const getPrebidMetrics = (type) => {
        const result = metricsOptions.filter(o => o.type === type);
        if(!includesOptions(DIMENSIONS, DISABLE_DIMENSION_AND_METRIC_SUPPORT)) {
            return result.map(o => {
                if(PRODUCT_METRIC_SUPPORT.includes(o.value)) {
                    return ({...o,isDisabled: true})
                }
                else return o;
            });
        } else {
          return result;
        }
    }

    const handleOnChange = (updatedValues, valuesToBeAddedOrRemoved) => {
        // check if the field is dimensions or metrics
        const key = Object.keys(updatedValues)[0];
        const isDimension = DIMENSION_TYPES.includes(key);
        const isMetric = METRICS_TYPES.includes(key);
        let updatePayload = { ...updatedValues };
        // if field is dimensions
        if(isDimension) {
            updatePayload.dimensions = addOrRemoveSelected(DIMENSIONS,valuesToBeAddedOrRemoved);
        }
        else if(isMetric) {
            updatePayload.metrics = addOrRemoveSelected(METRICS,valuesToBeAddedOrRemoved);
        }
        updatePayload = {...createPayload(updatePayload)};
        dispatch(updateReportForm({ ...formValues, ...updatePayload }));
    }



    const createPayload = (updatedValues) => {
        const selectProductType = updatedValues.dimensions && updatedValues.dimensions.includes(NO_PAGEVIEW_DIMENSION_SUPPORT);
        const productTypeNotSelected = updatedValues.dimensions && !updatedValues.dimensions.includes(PRODUCT_TYPE);
        const productTypeNotSupportedSelected = updatedValues.metrics && updatedValues.metrics.includes(NO_PAGEVIEW_METRIC_SUPPORT);
        if(selectProductType) {
            updatedValues.metrics = 'metrics' in formValues ? formValues.metrics.filter(o => !NO_PAGEVIEW_METRIC_SUPPORT.includes(o)) : [];
            updatedValues.monetizationMetrics = 'monetizationMetrics' in formValues ? formValues.metrics.filter(o => !NO_PAGEVIEW_METRIC_SUPPORT.includes(o)) : [];
        } else if(productTypeNotSelected) {
            updatedValues.dimensions = 'dimensions' in formValues ? updatedValues.dimensions.filter(o => !PRODUCT_METRIC_SUPPORT.includes(o)) : [];
            updatedValues.metrics = 'metrics' in formValues ? formValues.metrics.filter(o => !PRODUCT_METRIC_SUPPORT.includes(o)) : [];
            updatedValues.prebidMonetizationMetrics = 'prebidMonetizationMetrics' in formValues ? formValues.prebidMonetizationMetrics.filter(o => !PRODUCT_METRIC_SUPPORT.includes(o)) : [];
            updatedValues.prebidVideoMetrics = 'prebidVideoMetrics' in formValues ? formValues.prebidVideoMetrics.filter(o => !PRODUCT_METRIC_SUPPORT.includes(o)) : [];
        } else if(productTypeNotSupportedSelected) {
            updatedValues.dimensions = 'dimensions' in formValues ? formValues.dimensions.filter(o => o !== PRODUCT_TYPE) : [];
            updatedValues.standardDimension = 'standardDimension' in formValues ? formValues.standardDimension.filter(o => o !== PRODUCT_TYPE) : [];
        }
        return updatedValues;
    }



    const handleOnRemoval = (removedValues, valuesToBeUpdated) => {
        const isDimension = 'dimensions' in removedValues;
        const isMetric = 'metrics' in removedValues;
        const removedValueArr = Object.values(removedValues)[0];
        const updatedValues = {};

        if(isDimension) {
            updatedValues.standardDimension = valuesToBeUpdated && valuesToBeUpdated.length ? valuesToBeUpdated.filter(o => o.type === STANDARD_DIMENSION).map(o => o.value) : [];
            updatedValues.intervalDimension = valuesToBeUpdated && valuesToBeUpdated.length ? valuesToBeUpdated.filter(o => o.type === INTERVAL_DIMENSION).map(o => o.value) : [];
        } else {
            updatedValues.monetizationMetrics = valuesToBeUpdated && valuesToBeUpdated.length ? valuesToBeUpdated.filter(o => o.type === MONETIZATION_METRICS).map(o => o.value) : [];
            updatedValues.prebidMonetizationMetrics = valuesToBeUpdated && valuesToBeUpdated.length ? valuesToBeUpdated.filter(o => o.type === PREBID_MONETIZATION_METRICS).map(o => o.value) : [];
            updatedValues.performanceMetrics = valuesToBeUpdated && valuesToBeUpdated.length ? valuesToBeUpdated.filter(o => o.type === PERFORMANCE_METRICS).map(o => o.value) : [];
            updatedValues.prebidVideoMetrics = valuesToBeUpdated && valuesToBeUpdated.length ? valuesToBeUpdated.filter(o => o.type === PERFORMANCE_METRICS).map(o => o.value) : [];
        }

        handleOnChange(updatedValues , removedValueArr);
    }

    // this takes care of order change
    const handleOrderChange = newValues => {
        if(newValues.dimensions) {
            dispatch(updateReportForm({...formValues, dimensions: newValues.dimensions}));
        } else if(newValues.metrics) {
            dispatch(updateReportForm({...formValues, metrics: newValues.metrics}));
        }
    }

    const includesOptions = (field, options) => {
        return options.some(o => formValues[field].includes(o))
    }

    // add or remove from dimensions or metrics
    const addOrRemoveSelected = (field,values) => {
        let newValues;
        if(formValues[field] && formValues[field].length > 0 && includesOptions(field, values)){
            // find matching values between dimensions and values
            const toBeRemoved = values.filter(o => formValues[field].includes(o));
            const toBeIncluded = values.filter(o => !formValues[field].includes(o));
            //remove values that exist in dimension
            const currentValues = formValues[field].filter(o => !toBeRemoved.includes(o));
            newValues =  [...new Set([...currentValues, ...toBeIncluded])]
        } else {
            newValues =  [...new Set([...formValues[field], ...values])]
        }
        return newValues;
    }

    const getTipContent = () => {
        return includesOptions(METRICS, NO_PAGEVIEW_METRIC_SUPPORT)
            ? METRIC_FORM_PG_VIEW
            : DISABLE_PRODUCT_METRIC;
    };

    return (
        <>
            <ChecklistSection title={'Dimensions'}
                              isContentPresent={formValues[DIMENSIONS] && formValues[DIMENSIONS].length > 0}
                              checkListBody={
                                  <div className={`checkListSection ${props.classes.checkListSection}`}>
                                      <Checklist items={getDimensions(STANDARD_DIMENSION)}
                                                 options={DIMENSIONS_OPTIONS}
                                                 label={'Standard Dimensions'}
                                                 formValues={formValues}
                                                 field={STANDARD_DIMENSION}
                                                 disableItems={''}
                                                 handleOnChange={handleOnChange}
                                                 infoIcon={<Tip content={getTipContent()} />}
                                      ></Checklist>
                                      <Checklist items={getDimensions(INTERVAL_DIMENSION)}
                                                 options={DIMENSIONS_OPTIONS}
                                                 label={'Interval (Up to 1)'}
                                                 formValues={formValues}
                                                 field={INTERVAL_DIMENSION}
                                                 disableItems={''}
                                                 handleOnChange={handleOnChange}
                                                 mocked={mocked}></Checklist>
                                  </div>
                              }
                              selectedBody={
                                  <DraggableList
                                      handleOrderChange={handleOrderChange}
                                      handleOnRemoval={handleOnRemoval}
                                      handleOnChange={handleOnChange}
                                      field={DIMENSIONS}
                                      formValues={formValues}
                                      titlelink={
                                          <button className={`clearall ${props.classes.clearAll}`}>Clear All</button>
                                      }
                                      options={dimensionOptions}></DraggableList>
                              }
                              titlelink={
                                  <button className={`clearall ${props.classes.clearAll}`} onClick={() => handleOnRemoval({[DIMENSIONS] :formValues[DIMENSIONS]},[])}>Clear All</button>
                              }

            ></ChecklistSection>
            <ChecklistSection
                className={`metricsSection ${props.classes.metricsSection}`}
                title={'Metrics'}
                isContentPresent={formValues[METRICS] && formValues[METRICS].length > 0}
                checkListBody={
                <>
                    <div className={`checkListSection ${props.classes.checkListSection}`}>
                        <Checklist items={getMetrics(MONETIZATION_METRICS)}
                                   options={metricsOptions}
                                   label={`Monetization Metrics`}
                                   formValues={formValues}
                                   field={MONETIZATION_METRICS}
                                   disableItems={''}
                                   handleOnChange={handleOnChange}
                                   infoIcon={<Tip content={ includesOptions(METRICS, NO_PAGEVIEW_METRIC_SUPPORT) ? METRIC_FORM_PG_VIEW : DISABLE_PRODUCT_METRIC} />}

                        ></Checklist>
                        <Checklist items={getMetrics(PERFORMANCE_METRICS)}
                                   options={metricsOptions}
                                   label={`Performance Metrics`}
                                   formValues={formValues}
                                   field={PERFORMANCE_METRICS}
                                   disableItems={''}
                                   handleOnChange={handleOnChange}
                        ></Checklist>
                    </div>
                    <div className={`checkListSection ${props.classes.checkListSection}`}>
                        <Checklist items={getPrebidMetrics(PREBID_MONETIZATION_METRICS)}
                                   options={metricsOptions}
                                   label={`Prebid Monetization Metrics`}
                                   formValues={formValues}
                                   field={PREBID_MONETIZATION_METRICS}
                                   disableItems={''}
                                   handleOnChange={handleOnChange}
                                   icon={<Tip content={PRODUCT_SUPPORT_METRIC}/>}
                        ></Checklist>
                        {/* {mocked && <Checklist items={getPrebidMetrics(PREBID_VIDEO_METRICS)}
                                              options={metricsOptions}
                                              label={`Prebid Video Metrics`}
                                              formValues={formValues}
                                              field={PREBID_VIDEO_METRICS}
                                              disableItems={''}
                                              handleOnChange={handleOnChange}
                                              icon={<Tip content={PRODUCT_SUPPORT_METRIC}  />}

                        ></Checklist> } */}
                    </div>
                </>

            } selectedBody={
                <DraggableList
                    handleOrderChange={handleOrderChange}
                    handleOnRemoval={handleOnRemoval}
                    handleOnChange={handleOnChange}
                    field={METRICS}
                    formValues={formValues}
                    options={metricsOptions}></DraggableList>
            } titlelink={
                <button className={`clearall ${props.classes.clearAll}`} onClick={() => handleOnRemoval({[METRICS] :formValues[METRICS]},[])}>Clear All</button>
            }>


            </ChecklistSection>
        </>

    )
});